import { Injectable } from '@angular/core';

import { getGridVariants, type VariantLayout } from './grids.models';

@Injectable({
    providedIn: 'root',
})
export class GridsService {
    public getVariantLayout(variant: number) {
        const variants = getGridVariants();
        if (variants[variant]) {
            return this.prepareVariantLayout(variants[variant].layout);
        }

        return this.prepareVariantLayout(variants[0].layout);
    }

    private prepareVariantLayout(layout: VariantLayout): VariantLayout {
        let index = 0;
        return layout.map((row) => {
            return row.map((cell) => {
                return {
                    colSpan: cell.colSpan,
                    index: index++,
                };
            });
        });
    }
}
